// extracted by mini-css-extract-plugin
export default {"emptyDot":"empty-dot_emptyDot__NNMeA"};